export async function copyText(text: string): Promise<boolean> {
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch {
    /* fall through to legacy path */
  }
  try {
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(ta);
    return ok;
  } catch {
    return false;
  }
}

/*
 * 청첩장 slug → 손님용 공개 초대장 절대 주소.
 * 편집기·미리보기 화면에서도 항상 '공개 사이트' 주소로 링크가 만들어지도록,
 * 현재 화면의 주소(window.location.origin) 대신 공개 도메인을 기준으로 한다.
 * (미리보기 주소를 그대로 공유하면 로그인이 필요한 주소라 손님에게 오류가 뜬다.)
 */
const PUBLIC_SITE_ORIGIN: string =
  (import.meta.env.VITE_PUBLIC_SITE_URL as string | undefined) ||
  'https://wedding-invite.readdy.site';

export function inviteShareUrl(slug: string): string {
  const origin = PUBLIC_SITE_ORIGIN.replace(/\/+$/, '');
  return `${origin}/invite/${encodeURIComponent(slug)}`;
}